import { State } from "../types";

export type SetWithinGutterAction = Readonly<{
  gutter: "horizontal" | "vertical";
  position: [number, number];
  type: "SET WITHIN GUTTER";
}>;

export const setWithinGutter = (state: State, action: SetWithinGutterAction): State => {
  return {
    ...state,
    cells: state.cells.map(c => ({ ...c, selectedBorder: null })),
    mouseDragStart: null,
    mousePosition: action.position,
    withinGutter: action.gutter,
  };
};
